import React from "react";
import EmptyState from "../components/ui/EmptyState";
import InfoBanner from "../components/InfoBanner";

export default function DashboardRecommendations() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          Recommendations
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          Recommendations are not available yet.
        </p>
      </div>
      <InfoBanner
        title="Feature not ready"
        description="Recommendations will be available once the backend contract is finalized."
      />
      <EmptyState
        title="No recommendations yet"
        message="Recommendations will appear once analysis data is available."
        testId="dashboard-empty-recommendations"
      />
    </div>
  );
}
